import React, { useState } from "react";
import "./EditProfileModal.css";

const EditProfileModal = ({ isOpen, onClose, user, onSave }) => {
  const [formData, setFormData] = useState({
    name: user?.name || "",
    email: user?.emailid || "",
    phone: user?.phoneno || "",
    dob: user?.dob || "",
  });

  if (!isOpen) return null;

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onSave(formData);
  };

  return (
    <div className="pm-overlay">
      <div className="pm-container">
        
        {/* Header */}
        <div className="pm-header">
          <h2>Edit Profile</h2>
        </div>

        {/* Body */}
        <form className="pm-body" onSubmit={handleSubmit}>
          
          <div className="pm-field">
            <label>Name</label>
            <input
              type="text"
              name="name"
              value={formData.name}
              onChange={handleChange}
              required
            />
          </div>

          <div className="pm-field">
            <label>Email ID</label>
             <label>{formData.email}</label>
          </div>

          <div className="pm-field">
            <label>Phone Number</label>
            <input
              type="tel"
              name="phone"
              value={formData.phone}
              onChange={handleChange}
              required
            />
          </div>

          <div className="pm-field">
            <label>Date of Birth</label>
            <input
              type="date"
              name="dob"
              value={formData.dob}
              onChange={handleChange}
            />
          </div>

          {/* Footer */}
          <div className="pm-footer">
            <button type="button" className="pm-cancel" onClick={onClose}>
              Cancel
            </button>
            <button type="submit" className="pm-save">
              Save Changes
            </button>
          </div>

        </form>
      </div>
    </div>
  );
};

export default EditProfileModal;
